/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

interface Person {
  label: string;
  value: string;
  role: string;
}

function getTooltipTitle(person: Person): string {
  if (person.role && person.value) {
    const title = person.label !== person.value ? person.label : '';
    return `
      <h1 class="info-tooltip--title">${title}</h1>
      <p class="info-tooltip--code">${person.value}</p>
      <p class="info-tooltip--role">${person.role}</p>
    `;
  }
  return '';
}

export function getPersonLabel(person: Person): string {
  const { label, value } = person;
  return label ? label : value;
}

export function getPersonFullLabel(person: Person): string {
  const { label, value, role } = person;

  if (!role) {
    return `${label}`;
  }

  if (label && label !== value) {
    return `${label} (${value}) - ${role}`;
  }
  return `${value} - ${role}`;
}

export function getTooltipOptions(person: Person) {
  if (person.role && person.value) {
    return {
      title: getTooltipTitle(person),
      variant: 'info',
      html: true,
      template: `<div class="info-tooltip" role="tooltip">
          <div class="tooltip-inner"></div>
        </div>`,
      offset: '0, 5',
    };
  }
  return {};
}
